module.exports = __webpack_public_path__ + "media/flags/cy-bdb28a90.svg";